import React from 'react';
import ReactDOM from 'react-dom';

const AlertModal = ({ message, onClose, type = 'info', buttonText = '确定', onConfirm }) => {
  const typeStyles = {
    info: {
      backgroundColor: '#e3f2fd',
      borderColor: '#2196f3',
      color: '#1976d2'
    },
    warning: {
      backgroundColor: '#fff3e0',
      borderColor: '#ff9800',
      color: '#f57c00'
    },
    error: {
      backgroundColor: '#ffebee',
      borderColor: '#f44336',
      color: '#d32f2f'
    }
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  };

  const modalStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
    padding: '24px',
    maxWidth: '400px',
    width: '90%',
    margin: '20px',
    border: `2px solid ${typeStyles[type].borderColor}`,
    ...typeStyles[type]
  };

  const messageStyle = {
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: '20px',
    wordBreak: 'break-word'
  };

  const buttonStyle = {
    backgroundColor: typeStyles[type].borderColor,
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    outline: 'none'
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = async () => {
    if (onConfirm) {
      try {
        const result = onConfirm();
        // 检查是否是 Promise
        if (result && typeof result.then === 'function') {
          await result;
        }
      } catch (error) {
        console.error('onConfirm 执行失败:', error);
      }
    }
    onClose();
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={messageStyle}>{message}</div>
        <div style={{ textAlign: 'center' }}>
          <button
            style={buttonStyle}
            onClick={handleConfirm}
            onMouseOver={(e) => {
              e.target.style.opacity = '0.8';
            }}
            onMouseOut={(e) => {
              e.target.style.opacity = '1';
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

// 创建全局提示函数
let alertContainer = null;

const showAlert = (message, type = 'info', buttonText = '确定', onConfirm = null) => {
  return new Promise((resolve) => {
    // 如果已经有一个弹窗，先移除它
    if (alertContainer) {
      document.body.removeChild(alertContainer);
    }

    // 创建新的容器
    alertContainer = document.createElement('div');
    document.body.appendChild(alertContainer);

    const handleClose = () => {
      if (alertContainer && alertContainer.parentNode) {
        ReactDOM.unmountComponentAtNode(alertContainer);
        document.body.removeChild(alertContainer);
        alertContainer = null;
      }
      resolve();
    };

    // 渲染弹窗
    ReactDOM.render(
      <AlertModal 
        message={message} 
        onClose={handleClose} 
        type={type} 
        buttonText={buttonText}
        onConfirm={onConfirm}
      />,
      alertContainer
    );
  });
};

// 导出便捷方法
export const alert = (message, buttonText, onConfirm) => showAlert(message, 'info', buttonText, onConfirm);
export const alertWarning = (message, buttonText, onConfirm) => showAlert(message, 'warning', buttonText, onConfirm);
export const alertError = (message, buttonText, onConfirm) => showAlert(message, 'error', buttonText, onConfirm);

// 更灵活的配置方式
export const showCustomAlert = (config) => {
  const { 
    message, 
    type = 'info', 
    buttonText = '确定', 
    onConfirm = null 
  } = config;
  return showAlert(message, type, buttonText, onConfirm);
};

export default AlertModal; 